import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { firstMap } from "keautils";
import { fa } from "typed-font-awesome";


const columnasFijas: kea.Grid2Column<models.FacturaDto>[] = [
    {
        title: "Folio",
        cell: x => ({ data: x.SerieFolio })
    }, {
        title: "Saldo",
        cell: x => ({ data: x.Saldo, view: kea.formatCurrency })
    }, {
        title: "Total",
        cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency })
    }, {
        title: "Sig. no. parc.",
        cell: x => ({data: (x.UltNumParcialidadPago || 0) + 1 })
    } , {
        title: "Fecha creación",
        cell: x => ({ data: kea.toDate(x.FechaCreacion) })
    }, 
];


export function toGridItems(items: models.FacturaDto[], abonos: models.AbonoRepFactura[]) {
    return items.map<FacturaRep>(x => ({
        ...x,
        MontoRep: firstMap(abonos, y => y.IdFactura == x.IdRegistro, y => y.Monto) || 0
    }));
}

export interface FacturaRep extends models.FacturaDto {
    MontoRep: number;
}

export interface Deps {
    /**Cambiar el monto aplicado a cierta factura */
    onMontoChange: (factura: models.FacturaDto, monto: number) => void;
    /**Quitar esta factura del REP */
    onQuitar: (factura: models.FacturaDto) => void;
    getMontoFactura: (factura: models.FacturaDto) => number;

}

export function columnas(deps: Deps) {
    const cols: kea.Grid2Column<FacturaRep>[] = [
        kea.columnaBotones([
            {
                iconClass: fa("trash"),
                onClick: deps.onQuitar,
                tooltip: "Quitar"
            }
        ]), 
        ...columnasFijas,
        {
            title: "Monto REP",
            cell: x => ({
                data: deps.getMontoFactura(x),
                view: () => <kea.Number value={deps.getMontoFactura(x)} onChange={val => deps.onMontoChange(x, val || 0)} format="currency" />
            })
        }
    ];

    return cols;
}




// WEBPACK FOOTER //
// ./app/features/componentes/facturas/pagos/columnas.tsx